module.exports = __webpack_public_path__ + "24afed50903b1cbea7f17b8967d29728.png";